import React, { useState } from "react";
import {
    QueryClient,
    QueryClientProvider,
    QueryCache,
    MutationCache,
} from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools"; // ✅ normal import

import { message } from "antd";

export default function QueryProvider({ children }) {

    function handleGlobalError(error) {
        const msg = error instanceof Error ? error.message : String(error);

        if (typeof error === "object" && error !== null && "status" in error) {
            const status = error.status;

            if (status === 401) {
                console.log("Session expired detected");
                message.error("Session expired");
                return;
            }
        }

        console.error(msg);
    }

    const [queryClient] = useState(() => {
        return new QueryClient({
            queryCache: new QueryCache({
                onError: handleGlobalError,
            }),
            mutationCache: new MutationCache({
                onError: (error, variables, context, mutation) => {
                    if (
                        error?.message?.includes("ERR_NETWORK") ||
                        error?.message?.includes("Failed to fetch")
                    ) {
                        message.error(
                            "Network error. Check your internet connection and try again!"
                        );
                    }

                    if (!mutation.options.onError) {
                        handleGlobalError(error);
                    }
                },
            }),
            defaultOptions: {
                queries: {
                    gcTime: 1000 * 60 * 10,
                    staleTime: 1000 * 60 * 10,
                    retry: 1,
                    refetchOnWindowFocus: false,
                    refetchOnReconnect: true,
                },
                mutations: {
                    retry: false,
                },
            },
        });
    });

    return (
        <QueryClientProvider client={queryClient}>
            {children}
            {process.env.NODE_ENV === "development" && (
                <ReactQueryDevtools initialIsOpen={false} />
            )}
        </QueryClientProvider>
    );
}
